var styles = {
  "Bleed": "Polaris-Bleed"
};

export { styles as default };
